export class ToolStatus {
    static STORED_IN_LIFT = "STORED_IN_LIFT";
    static AT_ATOM_STATION = "AT_ATOM_STATION";
    static IN_TRANSPORT = "IN_TRANSPORT";
    static AT_LINE = "AT_LINE";
    static AT_FACILITY = "AT_FACILITY";
    static DELETED = "DELETED";
}
